import { render, staticRenderFns } from "./IncomesViews.vue?vue&type=template&id=08bcb2aa&"
import script from "./IncomesViews.vue?vue&type=script&lang=js&"
export * from "./IncomesViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports